import React from "react";
import { useContext } from "react";
import { AppContext } from "../AppContextProvider";
import { makeStyles, Grid, Paper, Table, TablePagination, TableRow, TableBody, Typography, Divider, Icon, ListItemText, Tooltip, IconButton } from "@material-ui/core";
import { blue, red, grey, blueGrey } from "@material-ui/core/colors";
import { TABLE_COUNTS } from "../Constants";
import { RowCountOptions } from "../Config";
// import EnhancedTableToolbar from "../components/EnhancedTableToolbar";
import EnhancedTableHead from "../components/EnhancedTableHead";
import { toInt, StyledTableCell, BootstrapTooltip, openMap } from "../Utils";
import ItemSelection from "../components/ItemSelection";
// import DateRangePickerCustom from "../components/DateRangePickerCustom";
import SearchBar from "../components/SearchBar";
import { PropertyService } from "../Services/PropertyService";
import { TenantService } from "../Services/TenantService";

const useStyles = makeStyles(theme => ({
    section: {
        width: '100%',
        height: '100%',
        marginTop: theme.spacing(1),
        paddingTop : theme.spacing(1),
        paddingBottom: theme.spacing(1)
    },
    qtyField: {
        width: "40%",
        position: "relative",
        [theme.breakpoints.up('md')]: {
            right: '100px',
            width: "10%",
            marginRight: 10
        },
        right: "22px"
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px',
    },
    grid: {
        [theme.breakpoints.up('md')]: {
            marginTop: '10px',
        },
        marginTop: '50px',
        marginBottom: '5px'
    },
    icon: {
        padding: '0px',
        [theme.breakpoints.up('md')]: {
            padding: '12px',
        },
    },
    tablecell: {
        fontSize: '16pt',
        padding: theme.spacing(4)
    },
    container: {
        paddingTop : theme.spacing(1)
    },
    redAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: red[500],
    },
    blueAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: blue[500],
    },
    instructions: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(3),
        marginBottom: theme.spacing(1),
    },
    button: {
        marginTop: theme.spacing(1),
        // height: theme.spacing(7),
        float: 'right',
        marginLeft: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
            float: 'inherit',
            marginLeft: theme.spacing(1)
        },
        marginRight: theme.spacing(4),
        
    }, 
    tableWrapper: {
        maxHeight: 407,
        overflow: 'auto',
    },
    list: {
        width: '100%',
        height: 250,
        overflow: "auto"
    },
    summary: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    title: {
        fontSize: 18,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    subtitle: {
        fontSize:18,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    selectRoot: {
        fontSize: 12,
        [theme.breakpoints.down('md')]: {
            marginLeft: 0,
            marginRight: 0
        },
    },
}));

export default function ViewTenants(props){

    const {setTitle, setLinearLoading, showProgressDialog, closeProgressDialog, showConfirmDialog, closeConfirmDialog, showSnackBar, openViewTenant, openModifyTenant} = useContext(AppContext);
    const classes = useStyles();
    const [selectedType, setSelectedType] = React.useState([]);
    const [filter, setFilter] = React.useState('');
    const [selectedProperty, setSelectedProperty] = React.useState(null);
    const [properties, setProperties] = React.useState([]);
    const [agreementStatus, setAgreementStatus] = React.useState([]);
    const [selectedStatus, setSelectedStatus] = React.useState(null);
    const [order, setOrder] = React.useState('asc');
    const [types, setTypes] = React.useState([]);
    const [orderBy, setOrderBy] = React.useState('name');
    const [currentRows, setCurrentRows] = React.useState([]);
    const [generate, setGenerate] = React.useState(true);
    const [loadedMaster, setLoadedMaster] = React.useState(false);
    const columns = [
        { id: 'index', align: 'left', numeric: false, disablePadding: false, label: 'Sl.No.', sortable: false },
        { id: 'name', align: 'justify', numeric: false, disablePadding: false, label: 'Name', sortable: true },
        { id: 'address1', align: 'center', numeric: false, disablePadding: true, label: 'Address', sortable: true },
        { id: 'mobile', align: 'center', numeric: false, disablePadding: true, label: 'Mobile', sortable: false },
        { id: 'email', align: 'center', numeric: false, disablePadding: true, label: 'Email', sortable: false },
        { id: 'type', align: 'center', numeric: false, disablePadding: true, label: 'Type', sortable: true },
        { id: 'properties', align: 'center', numeric: false, disablePadding: true, label: 'Properties', sortable: false },
        { id: 'action', align: 'right', numeric: true, disablePadding: false, label: '', sortable: false },
    ];

    //Pagination
    const [totalItems, setTotalItems] = React.useState(0);
    const [numItemsPerPage, setNumItemsPerPage] = React.useState(localStorage.getItem(TABLE_COUNTS.tenant_tab_count) ? toInt(localStorage.getItem(TABLE_COUNTS.tenant_tab_count)) : RowCountOptions[0]);
    const [currentPageNumber, setCurrentPageNumber] = React.useState(0);
    const [fetchPage, setFetchPage] = React.useState(false);

    const handleChangeRowsPerPage = event => {
        setNumItemsPerPage(event.target.value);
        setCurrentPageNumber(0);
        setFetchPage(true);
        localStorage.setItem(TABLE_COUNTS.tenant_tab_count, event.target.value);
    }

    const handleChangePage = (event, page) => {
        if(currentPageNumber > page){
            fetchRow(currentPageNumber - 1);
        } else {
            fetchRow(currentPageNumber + 1);
        }
    };

    const fetchRow = (newCurrentPage) => {
        setCurrentPageNumber(newCurrentPage);
        setFetchPage(true);
    }

    React.useEffect(() => {
        setTitle('Tenants');
        setLinearLoading(true);
        let data = [
            {
                id: "INDIVIDUAL",
                name: "INDIVIDUAL"
            },
            {
                id: "COMPANY",
                name: "COMPANY"
            },
        ];
        setTypes(data);
        let s = [{name: 'All Tenants', value: false}, {name: 'Current Tenants', value: true}];
        setAgreementStatus(s);
        setSelectedStatus(s[0]);
        PropertyService.getPropertyNames()
        .then(data => {
            setProperties(data);
            setLoadedMaster(true);
        })
        return () => {
            setTitle('');
        }
    }, [true]);

    React.useEffect(() => {
        // console.log(generate, loadedMaster)
        if(generate && loadedMaster){
            setCurrentRows([]);
            setLinearLoading(true);
            setCurrentPageNumber(0);
            setTotalItems(0);
            // setToolTitle(undefined);
            showProgressDialog();
            let types = selectedType && selectedType.length > 0 ? selectedType.map(s => s.id).join(',') : null;
            let property = selectedProperty ? selectedProperty.id : null;
            let fc = filter && filter.length > 0 ? filter : '';
            let current = selectedStatus.value ? true : null;
            TenantService.getTenantCount(property, types, current, fc)
            .then(data => {
                console.log(data);
                setTotalItems(toInt(data.count));
                setFetchPage(true);
                if(toInt(data.count) === 0){
                    setCurrentRows([]);
                }
                setLinearLoading(false);
            })
            .catch(error => {
                console.log(error);
                setLinearLoading(false);
            });
            setGenerate(false);
        }
    }, [generate, loadedMaster]);

    const openDialog = (id) => {
        openViewTenant(id, (shouldRefresh) => {
            if(shouldRefresh){
                setGenerate(true);
            }
        });
    }

    const handleEdit = (id) => {
        console.log(id);
        openModifyTenant(id);
    }

	const remove = (id) => {
		showProgressDialog('Removing Tenant...');
		TenantService.removeTenant(id)
		.then(() => {
            showSnackBar('Tenant Removed', 'info');
            closeProgressDialog();
            setGenerate(true);
		})
		.catch(error => {
			console.log(error);
			showConfirmDialog('Something went wrong. Please try again.', undefined, () => {
				closeConfirmDialog();
			});
			closeProgressDialog();
		})
    }
    
    const handleRemove = (id) => {
        console.log(id);
        showConfirmDialog(`Confirm Removal of Tenant? All Rental Agreements will also be removed.`, undefined, () => {
            closeConfirmDialog();
            remove(id);
        });
    }

    React.useEffect(() => {
        let rows = [];
        if(fetchPage) {
            setLinearLoading(true);
            let types = selectedType && selectedType.length > 0 ? selectedType.map(s => s.id).join(',') : null;
            let property = selectedProperty ? selectedProperty.id : null;
            let fc = filter && filter.length > 0 ? filter : '';
            let current = selectedStatus.value ? true : null;
            TenantService.getTenantList(property, types, current, fc, orderBy, order, currentPageNumber * numItemsPerPage, numItemsPerPage)
            .then((data) => {
                console.log(data);
                if(data){
                    data.forEach((element, index) => {
                        rows.push(
                            <TableRow 
                                key={index} 
                                hover
                                style={{cursor: 'pointer'}} 
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openDialog(element.id);
                                }}>
                                <StyledTableCell scope="row" align="center" padding='none' style={{width: 20}}>
                                    {index + 1 + (currentPageNumber * numItemsPerPage)}
                                </StyledTableCell>
                                <StyledTableCell scope="row" align="justify" padding='none'>
                                    <ListItemText
                                        primary={element.name || ''}
                                        secondary={element.designation || ''}
                                        secondaryTypographyProps={{style: {color: blueGrey[500]}}}
                                    />
                                </StyledTableCell>
                                <StyledTableCell scope="row" align="justify" padding='none'>
                                    <ListItemText
                                        primary={<span>{element.address1}<br/>
                                                    {element.address2 && (<span>{element.address2}<br/></span>)}
                                                    {element.city && (<span>{element.city}<br/></span>)}
                                                    {element.state && (<span>{element.state}<br/></span>)}
                                                    </span>}
                                        secondary={element.pincode}
                                        secondaryTypographyProps={{style: {color: grey[600]}}}
                                    />
                                </StyledTableCell>
                                <StyledTableCell scope="row" align="center" padding='none' onClick={(e) => {element.geo_coordinates && openMap(element.geo_coordinates)}}>
                                    {element.mobile}
                                </StyledTableCell>
                                <StyledTableCell scope="row" align="center" padding='none' style={{paddingRight: 16}}>
                                    {element.email}
                                </StyledTableCell>
                                <StyledTableCell scope="row" align="center" padding='none' style={{paddingRight: 16}}>
                                    {element.type ? element.type : '-'}
                                </StyledTableCell>
                                <StyledTableCell scope="row" align="center" padding='none'>
                                    {element.properties ? element.properties : '-'}
                                </StyledTableCell>
                                <StyledTableCell scope="row" align="right" padding='none' style={{paddingRight: 16}}>
                                    {
                                        element.active_tenant === 0 && (
                                            <BootstrapTooltip arrow title="Remove">
                                                <Icon 
                                                    fontSize="small"
                                                    color="error"
                                                    style={{marginTop: 8, marginRight: 16}} 
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleRemove(element.id)
                                                    }}>delete</Icon>
                                            </BootstrapTooltip>
                                        )
                                    }
                                    <BootstrapTooltip arrow title="Edit">
                                        <Icon 
                                            fontSize="small" 
                                            style={{marginTop: 8, marginRight: 8}} 
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleEdit(element.id)
                                            }}>edit</Icon>
                                    </BootstrapTooltip>
                                </StyledTableCell>
                            </TableRow>
                        );
                    });
                }
                setCurrentRows(rows);
                setLinearLoading(false);
                closeProgressDialog();
            })
            .catch(error => {
                console.log(error);
                setLinearLoading(false);
                closeProgressDialog();
            });
        }
        setFetchPage(false);
    }, [fetchPage]);

    const sortBy = (event, tenant) => {
        let o = 'desc';
        if (orderBy === tenant && order === 'desc') {
            o = 'asc';
        }
        setOrder(o);
        setOrderBy(tenant);
        setGenerate(true);
    }

    return (
        <div className="Home">
            <div className="lander">
                <Grid container direction="row" spacing={1} justify="center">
                    <Grid item xl={11} lg={12} xs={12}>
                        <Paper className={classes.section}>
                            <Grid container spacin={1} alignItems="center">
                                <Grid item xs={12} lg={2}>
                                    <ItemSelection 
                                        multiple 
                                        clearable={true} 
                                        label='Type' 
                                        value={selectedType} 
                                        optionLabel='name' 
                                        options={types} 
                                        selected={(value) => {
                                            setSelectedType(value);
                                            setGenerate(true);
                                        }}/>
                                </Grid>
                                <Grid item xs={12} lg={2}>
                                    <ItemSelection
                                        clearable={true} 
                                        optionLabel='name'
                                        label='Property' 
                                        value={selectedProperty} 
                                        labelTemplate={(option) => `${option.name} ${option.nickname ? `(${option.nickname})`: ''}`}
                                        options={properties} 
                                        selected={(value) => {
                                            setSelectedProperty(value);
                                            setGenerate(true);
                                        }}/>
                                </Grid>
                                <Grid item xs={12} lg={2}>
                                    <ItemSelection
                                        label='Tenant Status' 
                                        optionLabel='name'
                                        value={selectedStatus || null}
                                        options={agreementStatus} 
                                        selected={(value) => {
                                            setSelectedStatus(value);
                                            setGenerate(true);
                                        }}/>
                                </Grid>
                                <Grid item xs={12} lg={3}>
                                        {
                                            loadedMaster && (
                                                <div style={{float: 'right', marginTop: 8, marginRight: 8}}>
                                                    <SearchBar 
                                                        hint="Search..."
                                                        searchText={filter}
                                                        onTextChange={(e) => {
                                                        setFilter(e.target.value);
                                                        setGenerate(true);
                                                    }}/>
                                                </div>
                                            )
                                        }
                                </Grid>
                                <Grid item>
                                    <Tooltip title="Refresh">
                                        <IconButton size="medium" style={{marginTop: 8}} aria-label="Refresh" color="primary" onClick={() => {!generate && setGenerate(true)}}>
                                            <Icon>refresh</Icon>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={12} lg={12}>
                                    <Divider style={{marginBottom: 0, marginTop: 10}}/>
                                </Grid>
                                <Grid item xs={12} lg={12}>
                                    <div style={{minHeight: 100, overflowY: 'auto', display: 'block'}}>
                                        <Table className={classes.table} stickyHeader>
                                            <EnhancedTableHead
                                                order={order}
                                                orderBy={orderBy}
                                                onRequestSort={sortBy}
                                                rows={columns} />
                                            <TableBody>
                                                {currentRows}
                                            </TableBody>
                                        </Table>
                                    </div>
                                    {
                                        totalItems === 0 && 
                                            <Typography color="error" variant="subtitle2">No tenants to list</Typography>
                                    }
                                    <TablePagination
                                        rowsPerPageOptions={RowCountOptions}
                                        component="div"
                                        count={totalItems}
                                        rowsPerPage={numItemsPerPage}
                                        page={currentPageNumber}
                                        backIconButtonProps={{
                                            'aria-label': 'Previous Page',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'Next Page',
                                        }}
                                        onChangePage={handleChangePage}
                                        onChangeRowsPerPage={handleChangeRowsPerPage}
                                        classes={{ selectRoot : classes.selectRoot}}/>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </div>
    )
}